
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { getAllPosts } from '../../lib/blog';
import FormattedDate from '../../components/FormattedDate';
import { useRouter } from 'next/router';
async function getStaticProps({ locale, params }) {
    const page = 1;
    const postsPerPage = 6;
    const { posts, pagination } = getAllPosts(locale, page, postsPerPage);
    return {
        props: {
            posts,
            pagination
        }
    };
}
function Pagination({ pagination, locale }) {
    const { currentPage, totalPages } = pagination;
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    return (<div className="flex justify-center space-x-2 mt-8">
            {pages.map((page) => (<Link key={page} href={`/blog${page === 1 ? '' : `/page/${page}`}`} locale={locale} className={`px-4 py-2 rounded ${currentPage === page
                ? 'bg-[var(--secondary)] text-white'
                : 'bg-gray-200 hover:bg-gray-300'}`}>
                    {page}
                </Link>))}
        </div>);
}
function BlogPage({ posts, pagination }) {
    const { t, lang } = useTranslation('common');
    return (<div className="bg-white p-4 m-4 sm:rounded">
            <h1 className="text-2xl mb-6">{t('blog')}</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {posts.map((post) => (<Link href={`/blog/${post.slug}`} key={post.slug} className="group block overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-200">
                        <div className="relative h-48 w-full">
                            <Image src={post.image || '/images/blog-placeholder.jpg'} alt={post.title} fill sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" priority={true} className="object-cover"/>
                        </div>
                        <div className="p-4">
                            <h2 className="text-xl font-semibold mb-2 group-hover:text-[var(--secondary)] transition-colors">
                                {post.title}
                            </h2>
                            <div className="text-gray-600 text-sm mb-2">
                                <FormattedDate date={post.date} locale={lang} showTime={false}/>
                            </div>
                            <p className="text-gray-700 line-clamp-2">
                                {post.description}
                            </p>
                        </div>
                    </Link>))}
            </div>
            <Pagination pagination={pagination} locale={lang}/>
        </div>);
}
export default BlogPage;

    async function __Next_Translate__getStaticProps__1a1723ec729__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec729__ as getStaticProps }
  